import { Phone } from "lucide-react";
import { PHONE, PHONE_HREF } from "@/data/site";
import { QuoteForm } from "@/components/QuoteForm";
import { Reveal } from "@/components/Reveal";

export const CTABand = ({ idPrefix = "cta" }) => (
  <section id="quote" className="navy-grain text-white py-20 sm:py-28 px-4 sm:px-6" data-testid="cta-band">
    <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
      <Reveal>
        <p className="text-[#FF6500] font-heading font-bold uppercase tracking-widest text-sm mb-4">No Hot Water? We're On It.</p>
        <h2 className="font-heading font-extrabold text-4xl md:text-5xl tracking-tight leading-tight mb-6">
          Get Hot Water Back <span className="text-[#FF6500]">Today.</span>
        </h2>
        <p className="text-white/70 text-lg leading-relaxed mb-8">
          One call and a water heater specialist — not a call center — picks up. Same-day repair and replacement across Irvine and Orange County, 24/7.
        </p>
        <a href={PHONE_HREF} data-testid={`${idPrefix}-call-btn`} className="inline-flex items-center gap-3 bg-[#FF6500] text-white font-heading font-bold text-xl px-8 py-4 rounded-full hover:bg-[#E85C0D] hover:scale-105 transition-[background-color,transform]">
          <Phone className="w-6 h-6" /> {PHONE}
        </a>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 sm:p-8 backdrop-blur-sm">
          <h3 className="font-heading font-bold text-2xl mb-5">Request a Free Estimate</h3>
          <QuoteForm dark idPrefix={idPrefix} />
        </div>
      </Reveal>
    </div>
  </section>
);
